/**
 * ISO timestamps for the bottom time strip — 24 hourly steps on the selected calendar day.
 */
export function buildTimeSliderDates(historyDay: string): string[] {
  return Array.from({ length: 24 }, (_, i) => {
    const hour = String(i).padStart(2, '0');
    return `${historyDay}T${hour}:00:00`;
  });
}
